import { render, staticRenderFns } from "./OurChartIsEmptyPlaceholder.vue?vue&type=template&id=1dc56b4d&"
var script = {}
import style0 from "./OurChartIsEmptyPlaceholder.vue?vue&type=style&index=0&id=1dc56b4d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports